import React from 'react'
import styles from './LoginPasswordForm.module.css'
import { EmailIcon, INNIcon, LockIcon } from '../Icons/Icons'
import { useTranslation } from 'react-i18next'

export const LoginPasswordForm = ({
	login,
	password,
	handleLogin,
	handlePassword,
	handleSubmit,
	setAuthType,
	saveMe,
	toggleSaveMe,
	incorrectLoginAttempts,
	loginFailTimer,
	loading,
}) => {
	const { t, i18n } = useTranslation()

	return (
		<>
			<form className={styles.LoginPasswordFormWrapper} onSubmit={handleSubmit}>
				{/* <div className={styles.inputWrapper}>
          <INNIcon />
          <input
            className={styles.input}
            // onChange={handleLogin}
            placeholder="Вход по почте/ИИН"
            type="text"
            // value={login}
          />
        </div> */}
				<div className={styles.inputWrapper}>
					<EmailIcon />
					<input
						className={styles.input}
						onChange={handleLogin}
						placeholder={t('login.loginINN')}
						type='text'
						value={login}
					/>
				</div>
				<div className={styles.inputWrapper}>
					<LockIcon />
					<input
						className={styles.input}
						onChange={handlePassword}
						placeholder={t('login.yourPassword')}
						type='password'
						value={password}
					/>
				</div>
				{incorrectLoginAttempts >= 3 && (
					<div style={{ color: 'red' }}>
						<p>{t('login.attempt3')}</p>
						<p>
							{' '}
							{t('login.reAttempt')} {loginFailTimer}
						</p>
					</div>
				)}
				<div className={styles.RememberMe}>
					<div className={styles.CheckboxinputWrapper}>
						<input
							className={styles.input}
							checked={saveMe}
							onChange={toggleSaveMe}
							id='checkbox'
							type='checkbox'
						/>
					</div>
					<label htmlFor='checkbox'>{t('login.rememberMe')}</label>
				</div>

				<button
					className={`${styles.submit} ${
						incorrectLoginAttempts >= 3 || loading ? styles.buttonPressed : ''
					}`}
					type='submit'
					disabled={incorrectLoginAttempts >= 3 || loading}
				>
					{t('login.login')}
				</button>
			</form>
			<button
				className={styles.buttonLink}
				onClick={() => setAuthType('RECOVER')}
			>
				{t('login.forgot')}
			</button>
		</>
	)
}
